import React, { useState } from 'react';
import { Card, Input, Button, Form, Typography, message, Tabs } from 'antd';
import { KeyOutlined, UserOutlined, MailOutlined, RocketOutlined, LockOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import { API_BASE } from '../api';

const { Title, Text } = Typography;

const Login = ({ onLoginSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('login');
  const navigate = useNavigate();


  const handleLogin = async (values) => {
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE}/auth/login`, values);
      if (res.data.success) {
        localStorage.setItem('whatsapp_agent_api_key', res.data.apiKey);
        message.success(`Welcome back, ${res.data.user.name}`);
        onLoginSuccess(res.data.account);
        navigate('/agent-templates');




      }
    } catch (error) {
      message.error(error.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyLogin = async (values) => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE}/accounts/me`, {
        headers: { 'X-API-Key': values.apiKey }
      });
      if (res.data.success) {
        localStorage.setItem('whatsapp_agent_api_key', values.apiKey);
        message.success(`Logged in as ${res.data.account.name}`);
        onLoginSuccess(res.data.account);
        navigate('/agent-templates');


      }
    } catch (error) {
      message.error('Invalid API Key');
    } finally {
      setLoading(false);
    }
  };

  const onRegister = async (values) => {
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE}/auth/register`, values);
      if (res.data.success) {
        localStorage.setItem('whatsapp_agent_api_key', res.data.apiKey);
        message.success('Account created successfully!');
        onLoginSuccess(res.data.account);
        navigate('/agent-templates');


      }
    } catch (error) {
      message.error(error.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card">
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <RocketOutlined style={{ fontSize: 48, color: '#1890ff' }} />
          <Title level={2} style={{ marginTop: 16 }}>Agent Platform</Title>
          <Text type="secondary">Multi-Tenant WhatsApp AI Orchestrator</Text>
        </div>

        <Tabs 
          activeKey={activeTab} 
          onChange={setActiveTab} 
          centered
          items={[
            {
              key: 'login',
              label: 'Sign In',
              children: (
                <Form layout="vertical" onFinish={handleLogin}>
                  <Form.Item name="email" label="Email Address" rules={[{ required: true, type: 'email' }]}>
                    <Input prefix={<MailOutlined />} placeholder="admin@example.com" />
                  </Form.Item>
                  <Form.Item name="password" label="Password" rules={[{ required: true }]}>
                    <Input.Password prefix={<LockOutlined />} placeholder="Your password" />
                  </Form.Item>
                  <Form.Item style={{ marginBottom: 8 }}>
                    <Button type="primary" htmlType="submit" block loading={loading}>
                      Login
                    </Button>
                  </Form.Item>
                </Form>
              )
            },
            {
              key: 'register',
              label: 'Create Account',
              children: (
                <Form layout="vertical" onFinish={onRegister}>
                  <Form.Item name="name" label="Business Name" rules={[{ required: true }]}>
                    <Input prefix={<UserOutlined />} placeholder="Acme Inc." />
                  </Form.Item>
                  <Form.Item name="email" label="Email Address" rules={[{ required: true, type: 'email' }]}>
                    <Input prefix={<MailOutlined />} placeholder="admin@example.com" />
                  </Form.Item>
                  <Form.Item name="password" label="Password" rules={[{ required: true, min: 6 }]}>
                    <Input.Password prefix={<LockOutlined />} placeholder="Min 6 characters" />
                  </Form.Item>
                  <Form.Item style={{ marginBottom: 8 }}>
                    <Button type="primary" htmlType="submit" block loading={loading}>
                      Sign Up
                    </Button>
                  </Form.Item>
                </Form>
              )
            }
          ]}
        />
        
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Text type="secondary" style={{ fontSize: 12 }}>
            Demo User: <code style={{ color: '#eb2f96' }}>test@example.com</code> / <code style={{ color: '#eb2f96' }}>123456</code> (create first)
          </Text>
        </div>
      </Card>
      <style>{`
        .login-container {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          background: #f0f2f5;
        }
        .login-card {
          width: 420px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          border-radius: 12px;
        }
        [data-theme='dark'] .login-container {
          background: #000;
        }
      `}</style>
    </div>
  );
};

export default Login;
